declare global {
    interface Window {
      env: any
    }
  }
  
  type EnvType = {
    REACT_APP_BFF_URL: string,
    REACT_APP_BFF_TOKEN: string,
    REACT_APP_DD_APLICATIONID: string,
    REACT_APP_DD_CLIENT_TOKEN: string,
    REACT_APP_DD_SERVICE_NAME: string,
    REACT_APP_DD_SITE: string,
    REACT_APP_DD_ENV: string,
    REACT_APP_ENVIRONMENT: string,
    REACT_APP_PUBLIC_CERT: string,
    REACT_APP_MANUAL_BASE_URL: string
    REACT_APP_GTM_QA_ACTIVE: string
  }
  export const env: EnvType = { ...process.env, ...window.env }
  